"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sliceKey = exports.reducer = exports.betsProviderActions = exports.initialState = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const REDUCER_KEY = 'betsProvider';
exports.initialState = {
    quickBetStatus: {},
    isQuickBetActive: false,
};
const betsStateSlice = (0, toolkit_1.createSlice)({
    name: REDUCER_KEY,
    initialState: exports.initialState,
    reducers: {
        makeQuickBet: (state, { payload }) => { },
        makeQuickBetLoading: (state, { payload }) => {
            const { outcomeId } = payload;
            state.quickBetStatus[outcomeId] = { loading: true };
        },
        makeQuickBetSuccess: (state, { payload }) => {
            const { outcomeId, result } = payload;
            state.quickBetStatus[outcomeId] = { loading: false, result };
        },
        makeQuickBetError: (state, { payload }) => {
            const { outcomeId, error } = payload;
            state.quickBetStatus[outcomeId] = { loading: false, error };
        },
        clearMakeQuickBetState: (state, { payload }) => {
            const { outcomeId } = payload;
            delete state.quickBetStatus[outcomeId];
        },
        setQuickBetActive: (state, { payload }) => {
            const { isActive } = payload;
            state.isQuickBetActive = isActive;
        },
    },
});
exports.betsProviderActions = betsStateSlice.actions, exports.reducer = betsStateSlice.reducer, exports.sliceKey = betsStateSlice.name;
//# sourceMappingURL=slice.js.map